<template>
  <div class="product">
    <div v-if ="showQty && remainingQty>=0 && product.type==1" class="qty" v-bind:class="{ empty: remainingQty==0 }">{{remainingQty}}<span v-if="pendingQty >0">->{{pendingQty}}</span></div>
    <div v-if ="showQty && remainingQty<0 && product.type==1" class="qty" v-bind:class="{ empty: true }">0<span v-if="pendingQty >0">->{{pendingQty}}</span></div>
    <div>{{ itemName }}<span v-if="showProvider && product.provider!=null">, {{providerName(product.provider)}}</span></div>
    <div>
      <el-tag v-if="showInventoryName && inventoryName!=null"
        type="info"
        size="small"
        effect="dark">
        <span>
          {{inventoryName}}
        </span>
      </el-tag>
    </div>
    <span class="fs-14 secondary-text" v-if="product.type ==1 && showQty && quantityReserved>0">{{$t('reservation.qtyReservedField')}} {{ quantityReserved }}<br></span>
    <UnitFormatVolumeLabel v-if="product.type == 1" :unit="product.unit" :uvc="product.uvc" :format="format" :volume="volume"></UnitFormatVolumeLabel>
  </div>
</template>
<script>
import productUtils from '@/utils/portaus-utils';
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductUtil from '@/utils/product-util'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
export default {
  name: 'item-template',
	props: {
		product : Object,
    quantity : Object,
    inventory : Object,
    showQty : {
      type : Boolean,
      default : true
    },
    showInventoryName : {
      type : Boolean,
      default : true
    },
    showUnit : {
      type : Boolean,
      default : true
    },
    showProvider : {
      type : Boolean,
      default : true
    },
    volume : {
      type : Number
    },
    format : {
      type : Number
    }
	},
  data() {
    return {

    };
  },components: {
    UnitFormatVolumeLabel
  },
	methods: {

	},
	computed: {

    itemName(){
      if(this.product){
        return this.product.name;
      }
      return "";

    },
    inventoryName(){
      if(this.inventory==null)return null;
      return this.inventory.name;
    },
    sku(){
      return this.product.sku;

    },
    remainingQty(){
      if(this.quantity==null) return 0;
      return this.quantity.in_stock;
    },
    pendingQty(){
      if(this.quantity==null) return 0;
      return this.quantity.pending - this.quantity.reserved_new_shipement;
    },
    quantityReserved(){
      if(this.quantity==null) return 0;
      return this.quantity.reserved;
    },
    ...mapGetters('inventoryProducts',['providerName']),
	},
  created(){

  },mounted(){
    // console.log(this.product);
    // console.log(this.inventory);
    // console.log(this.quantity);
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.product{
  line-height:20px;
  margin:10px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}



</style>
